var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#827127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4 4 8.402 8.5 13"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M4.5 8.5h14.04"
  }))));
};
export default SvgBackArrow;